import { FunctionComponent } from 'react';
import { StyledProps } from '.';

interface VStackProps extends StyledProps {}

const VStack: FunctionComponent<VStackProps> = ({
  children,
  style,
  className,
  id,
}) => {
  return (
    <div
      className={className}
      id={id}
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default VStack;
